export enum PermissionType {
  ADMIN = 'ADMIN',
  BROKER = 'BROKER',
  BROKER_SALES = 'BROKER_SALES',
  UNDERWRITER = 'UNDERWRITER',
  ANALYST = 'ANALYST',
  ADVISOR = 'ADVISOR',
}
